import React from 'react';
import SideBarActivity from '../Component/CommonComponent/SideBarActivity/SideBarActivity';
import AppContents from './AppContents';

const Layout = () => {
  return (
    <div className="layout-container">
      <div className="sidebarss">
        <SideBarActivity />
      </div>
      <div className="main-contentss">
        <div className="app-contentsss">
          <AppContents />
        </div>
      </div>
    </div>
  );
};

export default Layout;
